module.exports = __webpack_public_path__ + "9ece07811c6ada0f284fc7d070d9db9a.png";


//////////////////
// WEBPACK FOOTER
// ./Res/img/sign_complete.png
// module id = 1771
// module chunks = 1